<template>
  <div class="pay-info">
    <van-nav-bar title="支付信息" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    
    <div class="pay-content">
      <div class="order-info">
        <div class="info-item">
          <span class="label">订单号：</span>
          <span class="value">{{ orderInfo.out_trade_no }}</span>
        </div>
        <div class="info-item">
          <span class="label">支付金额：</span>
          <span class="value">{{ getCurrencySymbol() }}{{ orderInfo.amount }}</span>
        </div>
        <div class="info-item">
          <span class="label">支付方式：</span>
          <span class="value">{{ orderInfo.paytype }}</span>
        </div>
      </div>

      <div class="qrcode-section">
        <div class="qrcode-title">请使用{{ getPayTypeText() }}扫码支付</div>
        <div class="qrcode-box">
          <img :src="qrcodeUrl" alt="支付二维码" />
        </div>
        <div class="qrcode-tips">
          <p>1. 请使用{{ getPayTypeText() }}扫描二维码完成支付</p>
          <p>2. 支付完成后请耐心等待系统自动确认</p>
          <p>3. 如遇到问题请联系客服处理</p>
        </div>
      </div>

      <div class="action-buttons">
        <van-button type="info" block @click="checkPayStatus">查看支付状态</van-button>
        <van-button  type="info" block style="margin-top: 10px" @click="$parent.openKefu">联系客服</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayInfo',
  data() {
    return {
      orderInfo: {},
      qrcodeUrl: '',
      timer: null
    }
  },
  created() {
    this.getPayInfo()
    // 每30秒检查一次支付状态
    this.timer = setInterval(() => {
      this.checkPayStatus()
    }, 300000000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getPayTypeText() {
      switch(this.orderInfo.paytype) {
        case '支付宝扫码支付':
          return '支付宝';
        case '微信扫码支付':
          return '微信';
        case '汇旺扫码支付':
          return '汇旺';
        default:
          return '对应';
      }
    },
    getCurrencySymbol() {
      if (this.orderInfo.paytype === '汇旺扫码支付') {
        return '$';
      }
      return '￥';
    },
    getPayInfo() {
      const deposit_no = this.$route.query.deposit_no
      if (!deposit_no) {
        this.$toast('订单号不存在')
        this.$router.back()
        return
      }

      this.$apiFun.post('/api/payinfo', { deposit_no })
        .then(res => {
          if (res.code === 200) {
            this.orderInfo = res.data.info
            this.qrcodeUrl = res.data.cardlist.payimg
          } else {
            this.$toast(res.message || '获取支付信息失败')
          }
        })
        .catch(err => {
          console.error('获取支付信息失败:', err)
          this.$toast('获取支付信息失败')
        })
    },
    checkPayStatus() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.pay-info {
  min-height: 100vh;
  background: #f8f8f8;
}

.pay-content {
  padding: 20px;
}

.order-info {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  margin-bottom: 10px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.label {
  color: #666;
  width: 80px;
}

.value {
  color: #333;
  flex: 1;
}

.qrcode-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.qrcode-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
}

.qrcode-box {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid #eee;
}

.qrcode-box img {
  width: 100%;
  height: 100%;
}

.qrcode-tips {
  margin-top: 15px;
  text-align: left;
  color: #666;
  font-size: 14px;
}

.qrcode-tips p {
  margin: 5px 0;
}

.action-buttons {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue